module.exports = __webpack_public_path__ + "img/logoutBlue.d76ea48d.svg";